import React from 'react';
import './App.css';
import { BrowserRouter } from "react-router-dom";
import Navbar from "./components/navbar";
import Router from "./pages/router";
import Footer from "./components/footer";
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Navbar />
        <Router />
        <Footer />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
